import React from 'react';
import { Controller, useFieldArray } from 'react-hook-form';
import { FormGroup, Label, Input, FormFeedback, Row, Col } from 'reactstrap';
import { Plus } from 'react-feather';
import BrandInSpaceRow from '../BrandInSpaceRow';

const Step5TakeWorkingRetailer = ({ control, errors, onBackToSelection }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'brand_in_space.brands',
  });

  const addBrand = () => {
    append({ brand_id: '', name: '', website: '' });
  };

  return (
    <div style={{
      maxWidth: '808px',
      width: '100%',
      background: '#fff',
      borderRadius: '10px',
      padding: '32px 36px',
    }}>
      <h5 style={{ fontWeight: '600', fontSize: '18px', marginBottom: '4px' }}>
        Take working with retailer
      </h5>
      <p style={{ color: '#888', fontSize: '13px', marginBottom: '28px' }}>
        Take working with retailer from brands in your space. Optionally use a brand ID to auto-fill name and website.
      </p>

      <div style={{ marginBottom: '24px' }}>
        <h6 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '16px' }}>
          Brand in Your Space <span style={{ color: '#e53' }}>*</span>
        </h6>

        {fields.map((field, index) => (
          <BrandInSpaceRow
            key={field.id}
            control={control}
            errors={errors}
            index={index}
            onRemove={() => remove(index)}
            canRemove={fields.length > 1}
            rowMarginBottom="16px"
          />
        ))}

        <button type="button" onClick={addBrand} style={addBtnStyle}>
          <Plus size={16} />
          Add another
        </button>
      </div>

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label style={labelStyle}>
              Match Type <span style={{ color: '#e53' }}>*</span>
            </Label>
            <Controller
              name="find_matches.match_type"
              control={control}
              render={({ field }) => (
                <Input
                  {...field}
                  type="select"
                  invalid={!!errors?.find_matches?.match_type}
                  style={inputStyle}
                >
                  <option value="">Select match type</option>
                  <option value="match">Match</option>
                  <option value="copy">Copy</option>
                </Input>
              )}
            />
            {errors?.find_matches?.match_type && (
              <FormFeedback style={{ display: 'block' }}>
                {errors.find_matches.match_type.message}
              </FormFeedback>
            )}
          </FormGroup>
        </Col>

        <Col md={6}>
          <FormGroup>
            <Label style={labelStyle}>
              Previous Matching <span style={{ color: '#e53' }}>*</span>
            </Label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', paddingTop: '10px' }}>
              <Controller
                name="find_matches.remove_previous_matching"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <label style={checkboxLabelStyle}>
                    <input
                      type="checkbox"
                      checked={value || false}
                      onChange={(e) => onChange(e.target.checked)}
                      style={{ marginRight: '8px', width: '16px', height: '16px' }}
                    />
                    Remove Previous matching
                  </label>
                )}
              />
            </div>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <FormGroup>
            <Label style={labelStyle}>
              Next To Brands &amp; Competitors
            </Label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', paddingTop: '10px' }}>
              <Controller
                name="brand_info.remove_existing_next_to_brands_competitors"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <label style={checkboxLabelStyle}>
                    <input
                      type="checkbox"
                      checked={value || false}
                      onChange={(e) => onChange(e.target.checked)}
                      style={{ marginRight: '8px', width: '16px', height: '16px' }}
                    />
                    Removing existing next to brands &amp; competitors
                  </label>
                )}
              />
            </div>
          </FormGroup>
        </Col>
      </Row>

      <div style={{ marginTop: '24px' }}>
        <button
          type="button"
          onClick={onBackToSelection}
          style={backLinkStyle}
        >
          ← Back to selection
        </button>
      </div>
    </div>
  );
};

const labelStyle = {
  fontSize: '13px',
  fontWeight: '500',
  color: '#333',
  marginBottom: '6px',
};

const inputStyle = {
  fontSize: '13px',
  borderRadius: '6px',
  border: '1px solid #d9d9d9',
  padding: '10px 12px',
  color: '#333',
};

const addBtnStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  background: 'none',
  border: 'none',
  color: '#222',
  fontSize: '13px',
  fontWeight: '500',
  cursor: 'pointer',
  padding: '6px 0',
};

const checkboxLabelStyle = {
  fontSize: '13px',
  color: '#333',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  margin: 0,
};

const backLinkStyle = {
  background: 'none',
  border: 'none',
  color: '#666',
  fontSize: '13px',
  cursor: 'pointer',
  padding: 0,
};

export default Step5TakeWorkingRetailer;
